// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReactIO = require("../../../shared/src/ReactIO.bs.js");
var Reselect = require("../../../shared/src/bindings/Reselect.bs.js");
var DateUtils = require("../../../shared/src/DateUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_Map = require("relude/src/Relude_Map.bs.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var BrowserStyle = require("../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_Shift = require("../../../shared/src/types/CommonTypes_Shift.bs.js");
var BrowserComponents_HR = require("../../../shared-browser/src/components/BrowserComponents_HR.bs.js");
var BrowserComponents_Icon = require("../../../shared-browser/src/components/BrowserComponents_Icon.bs.js");
var BrowserComponents_Text = require("../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var BrowserComponents_Button = require("../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");
var BrowserComponents_Dropdown = require("../../../shared-browser/src/components/BrowserComponents_Dropdown.bs.js");
var BrowserComponents_FlexColumn = require("../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");
var CommonTypes_Business_Location = require("../../../shared/src/types/business/CommonTypes_Business_Location.bs.js");
var BrowserComponents_AlertCountIndicator = require("../../../shared-browser/src/components/BrowserComponents_AlertCountIndicator.bs.js");

function eq(param, param$1) {
  return Curry._2(CommonTypes_Shift.Id.eq, param.shift.id, param$1.shift.id);
}

var ShiftNavigation = {
  eq: eq
};

function fromDate(timezone, date) {
  return {
          compareDate: DateUtils.formatDate(/* DateKey */2, /* Zone */{
                  _0: timezone
                })(date),
          formattedDate: DateUtils.formatDate(/* LongDateCompact */11, /* Zone */{
                  _0: timezone
                })(date)
        };
}

function compare(param, param$1) {
  return Curry._2(Relude_String.compare, param.compareDate, param$1.compareDate);
}

function eq$1(param, param$1) {
  return Relude_String.eq(param.compareDate, param$1.compareDate);
}

var Ord = {
  compare: compare,
  eq: eq$1
};

var $$Map = Relude_Map.WithOrd({
      eq: eq$1,
      compare: compare
    });

var DateNavigation = {
  fromDate: fromDate,
  compare: compare,
  eq: eq$1,
  Ord: Ord,
  $$Map: $$Map
};

function compare$1(param, param$1) {
  return CommonTypes_Business_Location.compare(param.location, param$1.location);
}

function eq$2(param, param$1) {
  return CommonTypes_Business_Location.eq(param.location, param$1.location);
}

var Ord$1 = {
  compare: compare$1,
  eq: eq$2
};

var $$Map$1 = Relude_Map.WithOrd({
      eq: eq$2,
      compare: compare$1
    });

var LocationNavigation = {
  compare: compare$1,
  eq: eq$2,
  Ord: Ord$1,
  $$Map: $$Map$1
};

function container(isActiveShift) {
  var arg = function (param, param$1) {
    return BrowserStyle.withFont(param, param$1, /* Small */2, /* Semibold */1);
  };
  return Curry._1(BrowserStyle.style, Curry._1(arg(undefined, undefined), {
                  hd: BrowserStyle.alignItems(BrowserStyle.center),
                  tl: {
                    hd: BrowserStyle.backgroundColor(isActiveShift ? ({
                              TAG: /* Grey */2,
                              _0: /* Lightest */4
                            }) : ({
                              TAG: /* White */7,
                              _0: /* Light */2
                            })),
                    tl: {
                      hd: BrowserStyle.borderRadius({
                            NAME: "rem",
                            VAL: 0.5
                          }),
                      tl: {
                        hd: BrowserStyle.color({
                              TAG: /* Grey */2,
                              _0: isActiveShift ? /* Dark */1 : /* Medium */2
                            }),
                        tl: {
                          hd: BrowserStyle.padding(BrowserStyle.Spacing.medium),
                          tl: {
                            hd: BrowserStyle.textAlign("left"),
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                }));
}

var shiftTypeImageAndShiftIdContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.flexBasis(BrowserStyle.rem(3.75)),
        tl: /* [] */0
      }
    });

var shiftTypeImage = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.height(BrowserStyle.rem(2.0)),
      tl: {
        hd: BrowserStyle.width(BrowserStyle.rem(2.0)),
        tl: /* [] */0
      }
    });

var shiftInfoContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.flexStart),
      tl: {
        hd: BrowserStyle.flex({
              NAME: "num",
              VAL: 1.0
            }),
        tl: {
          hd: BrowserStyle.minWidth(BrowserStyle.zero),
          tl: /* [] */0
        }
      }
    });

function shiftType(isActiveShift) {
  var arg = isActiveShift ? /* Bold */2 : /* Semibold */1;
  var arg$1 = function (param, param$1) {
    return BrowserStyle.withFont(param, param$1, /* Medium */3, arg);
  };
  return Curry._1(BrowserStyle.style, Curry._1(arg$1(undefined, undefined), {
                  hd: BrowserStyle.overflow(BrowserStyle.hidden),
                  tl: {
                    hd: BrowserStyle.maxWidth(BrowserStyle.pct(100.0)),
                    tl: {
                      hd: BrowserStyle.textOverflow(BrowserStyle.ellipsis),
                      tl: {
                        hd: BrowserStyle.whiteSpace(BrowserStyle.nowrap),
                        tl: /* [] */0
                      }
                    }
                  }
                }));
}

function hr(isActiveShift) {
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.borderColor(isActiveShift ? ({
                        TAG: /* White */7,
                        _0: /* Light */2
                      }) : ({
                        TAG: /* Grey */2,
                        _0: /* Lightest */4
                      })),
              tl: {
                hd: BrowserStyle.flex(BrowserStyle.none),
                tl: {
                  hd: BrowserStyle.margin2(BrowserStyle.zero, BrowserStyle.Spacing.medium),
                  tl: /* [] */0
                }
              }
            });
}

var Styles = {
  container: container,
  shiftTypeImageAndShiftIdContainer: shiftTypeImageAndShiftIdContainer,
  shiftTypeImage: shiftTypeImage,
  shiftInfoContainer: shiftInfoContainer,
  shiftType: shiftType,
  hr: hr
};

function WebComponents_ToDoShiftNavigation$Navigation$ShiftsList$Card(Props) {
  var alertCount = Props.alertCount;
  var isActiveShift = Props.isActiveShift;
  var onShiftNavigation = Props.onShiftNavigation;
  var param = Props.shift;
  var timezone = param.timezone;
  var startDatetime = param.startDatetime;
  var match = param.shiftType;
  var shiftId = param.id;
  return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Button.Base.make, {
                  children: React.createElement(BrowserComponents_FlexRow.make, {
                        className: container(isActiveShift),
                        children: null
                      }, React.createElement(BrowserComponents_FlexColumn.make, {
                            className: shiftTypeImageAndShiftIdContainer,
                            children: null
                          }, React.createElement(BrowserComponents_Icon.make, {
                                className: shiftTypeImage,
                                color: {
                                  TAG: /* Grey */2,
                                  _0: isActiveShift ? /* Dark */1 : /* Medium */2
                                },
                                icon: {
                                  TAG: /* Large */0,
                                  _0: {
                                    TAG: /* ShiftTypeCategory */2,
                                    _0: match.category
                                  }
                                }
                              }), React.createElement(BrowserComponents_Spacer.make, {
                                size: /* Small */3
                              }), React.createElement(BrowserComponents_Text.make, {
                                children: "#" + Curry._1(CommonTypes_Shift.Id.toString, shiftId)
                              })), React.createElement(BrowserComponents_Spacer.make, {
                            size: /* Medium */4
                          }), React.createElement(BrowserComponents_FlexColumn.make, {
                            className: shiftInfoContainer,
                            children: null
                          }, React.createElement(BrowserComponents_Text.make, {
                                className: shiftType(isActiveShift),
                                children: match.name
                              }), React.createElement(BrowserComponents_Spacer.make, {
                                size: /* Small */3
                              }), React.createElement(BrowserComponents_Text.make, {
                                children: DateUtils.formatDate(/* ShortDate */7, /* Zone */{
                                        _0: timezone
                                      })(startDatetime)
                              }), React.createElement(BrowserComponents_Spacer.make, {
                                size: /* XSmall */2
                              }), React.createElement(BrowserComponents_Text.make, {
                                children: DateUtils.formatDate(/* Time */14, /* Zone */{
                                        _0: timezone
                                      })(startDatetime) + (" - " + DateUtils.formatDate(/* Time */14, /* Zone */{
                                          _0: timezone
                                        })(param.endDatetime))
                              })), React.createElement(BrowserComponents_Spacer.make, {
                            size: /* Medium */4
                          }), React.createElement(BrowserComponents_AlertCountIndicator.make, {
                            alertCount: alertCount,
                            theme: {
                              backgroundColor: {
                                TAG: /* Grey */2,
                                _0: isActiveShift ? /* Dark */1 : /* Lightest */4
                              },
                              textColor: isActiveShift ? ({
                                    TAG: /* White */7,
                                    _0: /* Light */2
                                  }) : ({
                                    TAG: /* Grey */2,
                                    _0: /* Dark */1
                                  })
                            }
                          })),
                  onClick: (function (param) {
                      return Curry._1(onShiftNavigation, shiftId);
                    })
                }), React.createElement(BrowserComponents_HR.make, {
                  className: hr(isActiveShift)
                }));
}

var Card = {
  Styles: Styles,
  make: WebComponents_ToDoShiftNavigation$Navigation$ShiftsList$Card
};

function WebComponents_ToDoShiftNavigation$Navigation$ShiftsList(Props) {
  var onShiftNavigation = Props.onShiftNavigation;
  var selectedShiftId = Props.selectedShiftId;
  var shifts = Props.shifts;
  return Relude_List.toArray(Relude_List.map(function (param) {
                    var shift = param.shift;
                    var id = shift.id;
                    return React.createElement(WebComponents_ToDoShiftNavigation$Navigation$ShiftsList$Card, {
                                alertCount: param.alertCount,
                                isActiveShift: Relude_Option.fold(false, Curry._1(CommonTypes_Shift.Id.eq, id), selectedShiftId),
                                onShiftNavigation: onShiftNavigation,
                                shift: shift,
                                key: Curry._1(CommonTypes_Shift.Id.toString, id)
                              });
                  })(shifts));
}

var ShiftsList = {
  Card: Card,
  make: WebComponents_ToDoShiftNavigation$Navigation$ShiftsList
};

var getSortedDates = Reselect.createSelector1(undefined, Relude_Globals.id, (function (param) {
        return Relude_Globals.$great$great($$Map.keyArray, Relude_List.fromArray, param);
      }));

function WebComponents_ToDoShiftNavigation$Navigation$DatePicker(Props) {
  var clearSelectedShift = Props.clearSelectedShift;
  var dates = Props.dates;
  var defaultDate = Props.defaultDate;
  var onShiftNavigation = Props.onShiftNavigation;
  var selectedShiftId = Props.selectedShiftId;
  var match = ReactIO.useState(function (param) {
        return defaultDate;
      });
  var setSelectedDate = match[1];
  var selectedDate = match[0];
  var setSelectedDate$1 = function (date) {
    return Relude_IO.flatMap((function (param) {
                  return Curry._1(setSelectedDate, date);
                }), clearSelectedShift);
  };
  var partial_arg = Relude_IO.pure(undefined);
  var partial_arg$1 = function (param) {
    return Relude_Globals.$$const(partial_arg, param);
  };
  var partial_arg$2 = Relude_IO.flatMap((function (param) {
          return Curry._1(setSelectedDate, defaultDate);
        }), clearSelectedShift);
  var partial_arg$3 = function (param) {
    return Relude_Option.fold(partial_arg$2, partial_arg$1, param);
  };
  var partial_arg$4 = Curry._1($$Map.get, selectedDate);
  ReactIO.useEffect1(undefined, undefined, (function (param) {
          return Relude_Globals.$great$great(partial_arg$4, partial_arg$3, param);
        }), dates);
  return Relude_Option.fold(null, (function (shifts) {
                return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Dropdown.make, {
                                icon: {
                                  TAG: /* Shift */6,
                                  _0: /* CalendarDates */3
                                },
                                isItemSelected: (function (param) {
                                    return eq$1(selectedDate, param);
                                  }),
                                items: {
                                  TAG: /* List */1,
                                  _0: Curry._1(getSortedDates, dates)
                                },
                                itemToDisplayString: (function (param) {
                                    return param.formattedDate;
                                  }),
                                onSelectItem: setSelectedDate$1,
                                size: /* Small */1
                              }), React.createElement(BrowserComponents_Spacer.make, {
                                size: /* Medium */4
                              }), React.createElement(WebComponents_ToDoShiftNavigation$Navigation$ShiftsList, {
                                onShiftNavigation: onShiftNavigation,
                                selectedShiftId: selectedShiftId,
                                shifts: shifts
                              }));
              }), Curry._2($$Map.get, selectedDate, dates));
}

var DatePicker = {
  getSortedDates: getSortedDates,
  make: WebComponents_ToDoShiftNavigation$Navigation$DatePicker
};

function itemToDisplayString(param) {
  var formattedAlertCount = " (" + (Relude_Int.toString(param.alertCount) + ")");
  var name = param.location.name;
  if (Curry._2(Relude_Int.OrdNamed.greaterThanOrEq, 38, Relude_String.length(name + (" " + formattedAlertCount)))) {
    return Relude_String.slice(0, 35 - Relude_String.length(formattedAlertCount) | 0, name) + ("..." + formattedAlertCount);
  } else {
    return name + formattedAlertCount;
  }
}

var getSortedLocations = Reselect.createSelector1(undefined, Relude_Globals.id, (function (param) {
        return Relude_Globals.$great$great($$Map$1.keyArray, Relude_List.fromArray, param);
      }));

function WebComponents_ToDoShiftNavigation$Navigation(Props) {
  var clearSelectedShift = Props.clearSelectedShift;
  var defaultLocation = Props.defaultLocation;
  var locations = Props.locations;
  var onShiftNavigation = Props.onShiftNavigation;
  var selectedShiftId = Props.selectedShiftId;
  var match = ReactIO.useState(function (param) {
        return defaultLocation;
      });
  var setSelectedLocation = match[1];
  var selectedLocation = match[0];
  var selectedLocationId = selectedLocation.location.id;
  var setSelectedLocation$1 = function (date) {
    return Relude_IO.flatMap((function (param) {
                  return Curry._1(setSelectedLocation, date);
                }), clearSelectedShift);
  };
  var partial_arg = Relude_IO.pure(undefined);
  var partial_arg$1 = function (param) {
    return Relude_Globals.$$const(partial_arg, param);
  };
  var partial_arg$2 = Relude_IO.flatMap((function (param) {
          return Curry._1(setSelectedLocation, defaultLocation);
        }), clearSelectedShift);
  var partial_arg$3 = function (param) {
    return Relude_Option.fold(partial_arg$2, partial_arg$1, param);
  };
  var partial_arg$4 = Curry._1($$Map$1.get, selectedLocation);
  ReactIO.useEffect1(undefined, undefined, (function (param) {
          return Relude_Globals.$great$great(partial_arg$4, partial_arg$3, param);
        }), locations);
  return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Dropdown.make, {
                  isItemSelected: (function (param) {
                      return eq$2(selectedLocation, param);
                    }),
                  items: {
                    TAG: /* List */1,
                    _0: Curry._1(getSortedLocations, locations)
                  },
                  itemSelectedIcon: {
                    TAG: /* Status */8,
                    _0: /* CircleCheckedFilled */5
                  },
                  itemToDisplayString: itemToDisplayString,
                  onSelectItem: setSelectedLocation$1,
                  size: /* Small */1
                }), Relude_Option.fold(null, (function (dates) {
                    var __x = Curry._2(Relude_Option.flatMap, (function (selectedShiftId) {
                            return Relude_Option.map((function (param) {
                                          return param[0];
                                        }), Curry._2($$Map.find, (function (param, shifts) {
                                              return Relude_Option.isSome(Curry._2(Relude_List.find, (function (param) {
                                                                return Curry._2(CommonTypes_Shift.Id.eq, selectedShiftId, param.shift.id);
                                                              }), shifts));
                                            }), dates));
                          }), selectedShiftId);
                    return Relude_Option.fold(null, (function (defaultDate) {
                                  return React.createElement(React.Fragment, {
                                              children: null,
                                              key: "location" + Curry._1(CommonTypes_Business_Location.Id.toString, selectedLocationId)
                                            }, React.createElement(BrowserComponents_Spacer.make, {
                                                  size: /* Medium */4
                                                }), React.createElement(WebComponents_ToDoShiftNavigation$Navigation$DatePicker, {
                                                  clearSelectedShift: clearSelectedShift,
                                                  dates: dates,
                                                  defaultDate: defaultDate,
                                                  onShiftNavigation: onShiftNavigation,
                                                  selectedShiftId: selectedShiftId
                                                }));
                                }), Relude_Option.alt(__x, Relude_Array.head(Curry._1($$Map.keyArray, dates))));
                  }), Curry._2($$Map$1.get, selectedLocation, locations)));
}

var Navigation = {
  ShiftsList: ShiftsList,
  DatePicker: DatePicker,
  itemToDisplayString: itemToDisplayString,
  getSortedLocations: getSortedLocations,
  make: WebComponents_ToDoShiftNavigation$Navigation
};

function getShiftLocations(getAlertCountForShift) {
  var partial_arg = Curry._1(Relude_Array.map, (function (param) {
          var shifts = param[1];
          return [
                  {
                    alertCount: Curry._3(Relude_Array.foldLeft, (function (prim, prim$1) {
                            return prim + prim$1 | 0;
                          }), 0, Curry._2(Relude_Array.map, Curry.__1(getAlertCountForShift), shifts)),
                    location: param[0]
                  },
                  Curry._2($$Map.map, Relude_List.fromArray, Curry._2($$Map.groupArrayBy, (function (param) {
                              var match = param.shift;
                              return fromDate(match.timezone, match.startDatetime);
                            }), Curry._2(Relude_Array.map, (function (shift) {
                                  return {
                                          alertCount: Curry._1(getAlertCountForShift, shift),
                                          shift: shift
                                        };
                                }), shifts)))
                ];
        }));
  var partial_arg$1 = Curry._1(CommonTypes_Business_Location.$$Map.groupArrayBy, (function (param) {
          return param.location;
        }));
  var partial_arg$2 = function (param) {
    return Relude_Globals.$great$great(partial_arg$1, CommonTypes_Business_Location.$$Map.toArray, param);
  };
  var partial_arg$3 = function (param) {
    return Relude_Globals.$great$great(partial_arg$2, partial_arg, param);
  };
  return Reselect.createSelector1(undefined, Relude_Globals.id, (function (param) {
                return Relude_Globals.$great$great(partial_arg$3, $$Map$1.fromArray, param);
              }));
}

var container$1 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.borderRight({
            NAME: "rem",
            VAL: 0.0625
          }, BrowserStyle.solid, {
            TAG: /* Grey */2,
            _0: /* Lightest */4
          }),
      tl: {
        hd: BrowserStyle.flexBasis({
              NAME: "rem",
              VAL: 18.75
            }),
        tl: {
          hd: BrowserStyle.mobileMedia({
                hd: BrowserStyle.flex({
                      NAME: "num",
                      VAL: 1.0
                    }),
                tl: {
                  hd: BrowserStyle.padding(BrowserStyle.Spacing.medium),
                  tl: /* [] */0
                }
              }),
          tl: {
            hd: BrowserStyle.overflowY(BrowserStyle.scroll),
            tl: {
              hd: BrowserStyle.padding(BrowserStyle.Spacing.large),
              tl: /* [] */0
            }
          }
        }
      }
    });

var Styles$1 = {
  container: container$1
};

function WebComponents_ToDoShiftNavigation(Props) {
  var clearSelectedShift = Props.clearSelectedShift;
  var getAlertCountForShift = Props.getAlertCountForShift;
  var onShiftNavigation = Props.onShiftNavigation;
  var selectedShiftId = Props.selectedShiftId;
  var shifts = Props.shifts;
  var locations = getShiftLocations(getAlertCountForShift)(shifts);
  var __x = Curry._2(Relude_Option.flatMap, (function (selectedShiftId) {
          return Relude_Option.map((function (param) {
                        return param[0];
                      }), Curry._2($$Map$1.find, (function (_key, dates) {
                            return Relude_Option.isSome(Curry._2($$Map.find, (function (_key, shifts) {
                                              return Relude_Option.isSome(Curry._2(Relude_List.find, (function (param) {
                                                                return Curry._2(CommonTypes_Shift.Id.eq, selectedShiftId, param.shift.id);
                                                              }), shifts));
                                            }), dates));
                          }), locations));
        }), selectedShiftId);
  return React.createElement(BrowserComponents_FlexColumn.make, {
              className: container$1,
              children: Relude_Option.fold(null, (function (defaultLocation) {
                      return React.createElement(WebComponents_ToDoShiftNavigation$Navigation, {
                                  clearSelectedShift: clearSelectedShift,
                                  defaultLocation: defaultLocation,
                                  locations: locations,
                                  onShiftNavigation: onShiftNavigation,
                                  selectedShiftId: selectedShiftId
                                });
                    }), Relude_Option.alt(__x, Relude_Array.head(Curry._1($$Map$1.keyArray, locations))))
            });
}

var make = WebComponents_ToDoShiftNavigation;

exports.ShiftNavigation = ShiftNavigation;
exports.DateNavigation = DateNavigation;
exports.LocationNavigation = LocationNavigation;
exports.Navigation = Navigation;
exports.getShiftLocations = getShiftLocations;
exports.Styles = Styles$1;
exports.make = make;
/* Map Not a pure module */
